<template>
	<div style="overflow-x: hidden;overflow-y: hidden;">
		<div id="box">
			<div style="width: 100%;">
				<center>
					<h1 style="font-size: 1.75rem;padding-top: 1.25rem;"><span>{{title}}</span></h1>
				</center>
			</div>
			<el-divider></el-divider>
			<center>
				<pdf style="width: 80%;" ref="pdf" v-for="i in numPages" :key="i" :page="i" :src="pdfUrl">
				</pdf>
			</center>
			<!-- <center v-else-if="coin==='RVN'"><rvn class="markdown-body"/></center>
			<center v-else><xmrig class="markdown-body"/></center> -->
		</div>
	</div>
</template>

<script>
	// 
	// if("XMR"===coin){
	// 	import xmr from './Markdown/XMR.md'
	// }else if("ETH"===coin){
	// 	import xmr from './Markdown/XMR.md'
	// }
	import footerbar from '../../toolbar/footer.vue';
	import navbar from '../../toolbar/navbar.vue'
	import pdf from 'vue-pdf'
	export default {
		data() {
			return {
				title: 'Star Map - 教程',
				coin: 'XMR',
				pdfUrl: "https://labs-static.oss-cn-beijing.aliyuncs.com/pdf/course.pdf",
				numPages: null,
			}
		},
		components: {
			footerbar,
			navbar,
			pdf
		},
		mounted() {
			
			// let coin = this.$urlParse.getUrlKey('coin');
			// let lang = localStorage.getItem('locale') || 'zh'
			// if ("ETH" === coin) {
			// 	if (lang === 'zh') {
			// 		this.pdfUrl = "/static/ETH.pdf"
			// 	} else {
			// 		this.pdfUrl = "/static/ETH_en.pdf"
			// 	}
				
			// 	this.title = 'Ethereum (ETH)'
			// } else if ("RVN" === coin) {
			// 	if (lang === 'zh') {
			// 		this.pdfUrl = "/static/RVN.pdf"
			// 	} else {
			// 		this.pdfUrl = "/static/RVN_en.pdf"
			// 	}
				
			// 	this.title = 'Ravencoin (RVN)'
			// } else if ("XHV" === coin) {
			// 	this.pdfUrl = "/static/XHV.pdf"
			// 	this.title = 'Haven Protocol (XHV)'
			// } else if ("ERG" === coin) {
			// 	if (lang === 'zh') {
			// 		this.pdfUrl = "/static/ERG.pdf"
			// 	} else {
			// 		this.pdfUrl = "/static/ERGO_en.pdf"
			// 	}
			// 	this.title = 'Ergo (ERG)'
			// } else if ("XMR" === coin) {
			// 	if (lang === 'zh') {
			// 		this.pdfUrl = "/static/XMR.pdf"
			// 	} else {
			// 		this.pdfUrl = "/static/XMR_en.pdf"
			// 	}
			// 	this.title = 'Monero (XMR)'
			// } else if ("js" === coin) {
			// 	this.pdfUrl = "/static/js.pdf"
			// 	this.title = '猫池(C3Pool.com)介绍'
			// } else if ("zdsf" === coin) {
			// 	this.pdfUrl = "/static/zdsf.pdf"
			// 	this.title = '如何指定算法挖矿'
			// } else if ("morehelp" === coin) {
			// 	this.pdfUrl = "/static/morehelp.pdf"
			// 	this.title = '猫池(C3Pool.com)教程传送门'
			// } else if ("XMR_linux" === coin) {
			// 	this.pdfUrl = "/static/XMR_linux.pdf"
			// 	this.title = 'How to mine Monero on Linux'
			// } else if ("XMR_win" === coin) {
			// 	this.pdfUrl = "/static/XMR_win.pdf"
			// 	this.title = 'How to mine Monero on Windows'
			// } else if ("ETH_en" === coin) {
			// 	this.pdfUrl = "/static/ETH_en.pdf"
			// 	this.title = 'How to mine Ethereum and get XMR rewards'
			// } else if ("RVN_en" === coin) {
			// 	this.pdfUrl = "/static/RVN_en.pdf"
			// 	this.title = 'How to mine Ravencoin and get XMR rewards'
			// } else if ("ERGO_en" === coin) {
			// 	this.pdfUrl = "/static/ERGO_en.pdf"
			// 	this.title = 'How to mine ERGO and get XMR rewards'
			// } else {
			// 	this.pdfUrl = "/static/XMR.pdf"
			// 	this.title = '配置及使用xmrig挖掘工具'
			// }
			// this.coin = coin
			this.getNumPages()
		},
		methods: {

			getNumPages() {
				let loadingTask = pdf.createLoadingTask(this.pdfUrl)
				loadingTask.promise.then(pdf => {
					this.numPages = pdf.numPages
				}).catch(err => {
					console.error('pdf 加载失败', err);
				})
			}
		}

	};
</script>

<style scoped>
	#box {
		background-color: white;
		width: 70%;
		margin: auto;
		margin-top: 5rem;
		padding-bottom: 2.5rem;
		margin-bottom: 5rem;
		border-radius: 0.5rem;
		box-shadow: 1px 0px 7px 1px rgba(0, 0, 0, .1);
		-webkit-box-shadow: 1px 0px 7px 1px rgba(0, 0, 0, .1);
	}
</style>
